<template>
    <div class="product-select" itemscope itemprop="offers" itemtype="https://schema.org/Offer">
        <template v-if="product.status">
            <product-price :product='product'/>
            <div v-if="product.related_products" class="product-options">
                <span class="product-select-title">Варианты модели</span>
                <div>
                    <div class="active product-options-item">
                        <img :src="product.images.filter(i => i.type !== 'video')[0].preview"
                             :alt="product.name">
                    </div>
                    <a v-for="relateProduct in product.related_products"
                       :key="relateProduct.id"
                       v-if="relateProduct.id !== product.id && relateProduct.url"
                       :href="relateProduct.url"
                       class="product-options-item"
                    >
                        <img :src="relateProduct.preview" :alt="product.name">
                    </a>
                </div>
            </div>
            <div v-if="product.sizes" class="product-size">
                <template v-if="product.size_required">
                    <span class="product-select-title">Размеры в наличии</span>
                    <div class="product-size-items" :data-id="product.id">
                        <div v-for="(size, index) in product.sizes" :key="index"
                             class="product-size-item"
                             :class="{ 'active': sizeIsSelected(size), 'product-size-item-long': size.length > 4 }"
                             @click="toggleSize({productId: product.id, size: size})">{{ size }}
                        </div>
                    </div>
                </template>
                <store-sizes class="mb-2"
                             v-if="$root.cityName === 'Омск' && product.store"
                             :label="product.size_required ? 'Наличие размеров в магазине' : 'Наличие в магазине'"
                             :stores="product.store"></store-sizes>
                <size-selection v-if="tableSizes.length"
                                :product="product"
                                :brand="brand"
                                :brand-sizes="brandSizes"
                                :size-keys="sizeKeys"
                                :table-sizes="tableSizes"
                                :table-size-labels="tableSizeLabels"
                                :slug="slug">
                </size-selection>
            </div>
            <div class="product-actions">
                <span class="product-add-to-cart"
                      :data-id="product.id"
                      :data-size_required="product.size_required"
                      @click.prevent='addProductToCart'>
                    Добавить в корзину
                </span>
                <span class="product-one-click" @click='oneClick'>Купить в 1 клик</span>
            </div>
        </template>
        <template v-else>
            <div v-if="product.price && waitingListAvailable" class="last-price">Последняя цена:</div>
            <div v-if="product.price && waitingListAvailable" class="product-price">
                <div class="product-price-container">
                    <div itemprop="price"
                         :content="product.price"
                         class="product-price-total product-price-total--sale">
                        {{ product.price }}<span class="rub"> руб</span>
                    </div>
                </div>
            </div>
            <div class="out-of-stock">Нет в наличии</div>
            <span v-if="!logged && waitingListAvailable"
                  class="btn btn-outline add-to-waiting-list"
                  @click="loginForWaitingList">Сообщить о поступлении</span>
            <add-to-waiting-list v-if="logged && waitingListAvailable"
                                 :product="product"
                                 :sizes="sizes"
                                 :size-required="product.size_required"></add-to-waiting-list>
        </template>
        <ul class="product-purchase">
            <li class="icon purchase-after-fitting"><span>Оплата после примерки</span></li>
            <li v-if="product.category_group?.id === 1" class="icon two-years-warranty"><span>2 года гарантии</span></li>
            <li v-else class="icon free-shipping"><span>Бесплатная доставка</span></li>
            <li class="icon original-brand"><span>100% оригинальные бренды</span></li>
        </ul>
        <link :href="url" itemprop="url">
        <meta itemprop="priceCurrency" content="RUB">
        <link v-if="product.status === 1" itemprop="availability" href="http://schema.org/InStock">
        <link v-else itemprop="availability" href="http://schema.org/OutOfStock">
    </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import AddToWaitingList from './AddToWaitingList';

export default {
    props: [
        'productData',
        'brandSizes',
        'sizeKeys',
        'brand',
        'showHowSelectSize',
        'sizes',
        'waitingListAvailable',
        'bonusAccumulationPercentage'
    ],
    data() {
        return {
            url: window.location.href,
            tableSizes: [],
            tableSizeLabels: [],
            slug: '',
        }
    },
    components: {
        'add-to-waiting-list': AddToWaitingList
    },
    computed: {
        ...mapState('auth', ['logged']),
        ...mapState('product', ['product']),
        ...mapGetters('product', ['sizeSelected']),
        promoCodeApplied() {
            return this.product.promo_code && this.product.applied;
        },
        isFavorite() {
            return this.$root.isFavorite(this.product.id);
        },
    },
    mounted() {
        this.$store.commit('product/setBonusAccumulationPercentage', this.bonusAccumulationPercentage);
        this.setProduct(this.productData);
        this.$store.commit('geo/loadDeliveryDataOnCityChange');
        this.loadData();
    },
    methods: {
        loadData() {
            let _this = this;

            axios.get('/products/' + this.product.id + '/additional-data')
                .then(response => {
                    _this.$store.commit('delivery/setDeliveries', response.data.deliveries);
                    _this.$store.commit('product/setReviews', response.data.reviews);
                    _this.$store.commit('product/setQuestions', response.data.questions);
                    _this.$store.commit('product/setAssociatedProducts', response.data.associatedProducts);
                    _this.$store.commit('product/setLastViewedProducts', response.data.lastViewedProducts);
                    _this.$store.commit('product/setAssociatedAccessoryProducts', response.data.associatedAccessoryProducts);

                    window.products = window.products || [];
                    window.products = window.products.concat(response.data.associatedProducts.brand || []);
                    window.products = window.products.concat(response.data.associatedProducts.category || []);
                    window.products = window.products.concat(response.data.associatedProducts.color || []);
                    window.products = window.products.concat(response.data.lastViewedProducts || []);
                    window.products = window.products.concat(response.data.associatedAccessoryProducts || []);
                    this.tableSizeLabels = response.data.tableSizeLabels;
                    this.tableSizes = response.data.tableSizes;
                    this.slug = response.data.slug;
                });
        },
        ...mapMutations({
            toggleSize: 'product/toggleSize',
            showProductSizeModal: 'product/showProductSizeModal',
            showOneClickOrderModal: 'cart/showOneClickOrderModal',
            showAddToCartModal: 'cart/showAddToCartModal',
            setProduct: 'product/setProduct',
            skipAddToCartEvent: 'product/skipAddToCartEvent',
        }),
        ...mapMutations('auth', {
            showAuthModal: 'showModal',
            stayOnPageAfterAuth: 'stayOnPageAfterAuth'
        }),
        ...mapActions({
            addProduct: 'cart/addProduct',
        }),
        sizeIsSelected(size) {
            return this.sizeSelected(this.product.id, size);
        },
        addProductToCart() {
            this.addProduct({
                productId: this.product.id,
                sizeRequired: this.product.size_required
            })
                .then(() => {
                    this.showAddToCartModal();
                })
                .catch(error => {
                    if (error.reason === 'no_size_selected') {
                        this.skipAddToCartEvent(false);
                        this.showProductSizeModal([{'cart/toggleAddToCartModal': true}]);
                    } else if (error.response && error.response.data && error.response.data.product) {
                        this.setProduct(error.response.data.product);
                    }
                });
        },
        oneClick() {
            this.addProduct({
                productId: this.product.id,
                sizeRequired: this.product.size_required,
                erase: true
            })
                .then(() => {
                    this.showOneClickOrderModal();
                })
                .catch(error => {
                    if (error.reason === 'no_size_selected') {
                        this.skipAddToCartEvent(true);
                        this.showProductSizeModal([{'cart/toggleOneClickOrderModal': true}]);
                    } else if (error.response && error.response.data && error.response.data.product) {
                        this.setProduct(error.response.data.product);
                    }
                });
        },
        switchFavorites() {
            this.$root.switchFavorites(this.product.id)
        },
        loginForWaitingList() {
            this.stayOnPageAfterAuth('addToWaitingList');
            this.showAuthModal();
        }
    },
}
</script>
